import React from 'react';

const RAZORPAY_KEY_ID = 'rzp_live_MrgSMK6JvPB86Q';

export const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

export const initiateRazorpayPayment = async (options = {}) => {
  const isScriptLoaded = await loadRazorpayScript();
  if (!isScriptLoaded) {
    alert('Payment gateway is currently unavailable. Please try again later.');
    return false;
  }

  const defaultOptions = {
    key: RAZORPAY_KEY_ID,
    currency: 'INR',
    name: 'YinGuru',
    description: '24 Ways to Double Your Sales - Diwali Special',
    image: 'https://greta-preview.s3.us-east-2.amazonaws.com/assets/logo.svg',
    prefill: {
      name: '',
      email: '',
      contact: ''
    },
    notes: {
      product: 'diwali-ebook'
    },
    theme: {
      color: '#4B2E83'
    },
    modal: {
      backdropclose: false,
      escape: false,
      handleback: false,
      confirm_close: true,
      ondismiss: function() {
        console.log('Payment cancelled by user');
      }
    }
  };

  const finalOptions = { ...defaultOptions, ...options };

  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      ...finalOptions,
      handler: function(response) {
        resolve({
          success: true,
          paymentId: response.razorpay_payment_id,
          orderId: response.razorpay_order_id,
          signature: response.razorpay_signature
        });
      },
      modal: {
        ...finalOptions.modal,
        ondismiss: function() {
          resolve({
            success: false,
            error: 'Payment cancelled by user'
          });
        }
      }
    });

    rzp.on('payment.failed', function(response) {
      resolve({
        success: false,
        error: response.error.description,
        code: response.error.code
      });
    });

    rzp.open();
  });
};

export const validatePaymentDetails = (email, name, phone) => {
  const errors = {};

  if (!email) {
    errors.email = 'Email is required';
  } else if (!/^\S+@\S+\.\S+$/.test(email)) {
    errors.email = 'Please enter a valid email';
  }

  if (!name) {
    errors.name = 'Name is required';
  } else if (name.trim().length < 2) {
    errors.name = 'Please enter a valid name';
  }

  if (!phone) {
    errors.phone = 'Phone number is required';
  } else if (!/^[6-9]\d{9}$/.test(phone)) {
    errors.phone = 'Please enter a valid 10-digit mobile number';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};